import { useCallback, useState } from 'react';

import useFetch from 'hooks/useFetch';

import { JOHN_DEERE_TREE_API } from './constants';
import type { JohnDeereTreeClient, UseJohnDeereTreeReturn } from './types';

const FETCH_PARAMS = {
    apiHost: import.meta.env.VITE_JD_API_BASE_URL || '',
    headers: { 'Content-Type': 'application/json' }
};

const useJohnDeereTree = (): UseJohnDeereTreeReturn => {
    const [tree, setTree] = useState<JohnDeereTreeClient[]>([]);
    const [isLoading, setIsLoading] = useState(false);

    const { authenticatedGet } = useFetch(FETCH_PARAMS);

    const fetch = useCallback(
        async ({ organizationId }: { organizationId: string }) => {
            try {
                setIsLoading(true);

                const response = await authenticatedGet<JohnDeereTreeClient[]>(
                    `${JOHN_DEERE_TREE_API}/${organizationId}/tree`
                );

                if (response.data) {
                    setTree(response.data);
                }

                if (response.error) {
                    console.error('Failed to fetch JD tree:', response.error);
                }
            } finally {
                setIsLoading(false);
            }
        },
        [authenticatedGet]
    );

    return {
        fetch,
        isLoading,
        tree
    };
};

export default useJohnDeereTree;
